import { logger } from '@fiverr-private/obs';
import { isAxiosError } from '../isAxiosError';

const DEFAULT_ENRICHMENT = {
    package: '@fiverr-private/identification_core',
};

interface Payload {
    error?: unknown;
    message?: string;
    enrichment?: Record<string, unknown>;
}

export const logError = ({ error, message, enrichment }: Payload) => {
    const mergedEnrichment = {
        ...DEFAULT_ENRICHMENT,
        ...enrichment,
    };

    if (isAxiosError(error)) {
        logger.error({
            message: message ?? error.message,
            error,
            request: {
                headers: error.config.headers,
                method: error.config.method,
                url: error.config.url,
            },
            response: error.response?.data,
            details: mergedEnrichment,
        });
    } else if (error instanceof Error) {
        logger.error({
            message: message ?? error.message,
            error,
            details: mergedEnrichment,
        });
    } else if (message) {
        logger.error({ message, details: mergedEnrichment });
    }
};
